<a class="btn btn-circle btn-default" (click)="actionsEmit()" >
  <i class="{{buttonIcon}}" aria-hidden="true" style="padding-right: 3px ;  color: unset;"></i>
  {{  buttonTitle | translate:locale.language }}
</a>
